module.exports = __webpack_public_path__ + "static/media/Driveway1.128c080c.jpg";